import { render } from "./ModuleInfo.vue?vue&type=template&id=cb6a5288"
import script from "./ModuleInfo.vue?vue&type=script&lang=js"
export * from "./ModuleInfo.vue?vue&type=script&lang=js"

import "./ModuleInfo.vue?vue&type=style&index=0&id=cb6a5288&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__